import React, { useState, useRef, useEffect } from 'react';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Dialog, DialogActions, DialogContent, Tabs, Tab, Box, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { IsEmpty } from '../../common/checks';
import ApiService from '../../services.js/apiService';
import { Status } from '../../common/constants';

const ViewPostsReviews = (props) => {
  const postTable = useRef(null);
  const reviewTable = useRef(null);
  const poiTable = useRef(null);
  const [tab, setTab] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchableStatus, setSearchableStatus] = useState('');

  useEffect(() => {
    if (postTable.current) {
      postTable.current.onQueryChange();
    }
  }, [searchableStatus]);

  const handleChange = (event) => {
    if (event.target.name === 'searchableStatus') {
      setSearchableStatus(event.target.value);
    }
  };

  return (
    <>
      <Dialog open fullScreen onClose={() => props.changeOpenModal()} aria-labelledby="form-dialog-title">
        <DialogContent id="form-dialog-content">

          <h2 className="mb-4">
            You are viewing tag:
            {' '}
            <strong style={{ color: '#f50057' }}>{props.tag}</strong>
          </h2>
          <hr />

          <Tabs
            value={tab}
            onChange={(e, value) => setTab(value)}
            className="mb-2"
          >
            <Tab value={1} label="Posts" style={{ fontSize: 18 }} />
            <Tab value={2} label="Reviews" style={{ fontSize: 18 }} />
            <Tab value={3} label="Pois" style={{ fontSize: 18 }} />
          </Tabs>

          {tab === 1 && (
            <div>
              <MaterialTable
                title=""
                tableRef={postTable}
                columns={
                  [
                    {
                      title:  'Id',
                      field:  'id',
                      render: (post) => (
                        <a href={`/admin/page/${post.pageId}/post/${post.id}`} target="_blank" rel="noreferrer">{ post.id }</a>
                      ),
                    },
                    {
                      title: 'Brand',
                      field: 'brand',
                    },
                    {
                      title:  'Title',
                      field:  'title',
                      render: (post) => {
                        const maxLength = 50;
                        if (!IsEmpty(post.title)) {
                          return (
                            <a href={`/admin/page/${post.pageId}/post/${post.id}`} target="_blank" rel="noreferrer">
                              { (post.title.length >= maxLength) ? `${post.title.substring(0, maxLength)}...` : post.title }
                            </a>
                          );
                        }
                      },
                    },
                    {
                      title: 'Post Date',
                      field: 'postDate',
                    },
                    {
                      title: 'Status',
                      field: 'status',
                    },
                    {
                      title: 'Searchable Status',
                      field: 'searchableStatus',
                    },
                  ]
                }
                onChangeRowsPerPage={(val) => setPageSize(val)}
                data={(query) => new Promise(async (resolve) => {
                  try {
                    const { page } = query;
                    const { result, totalCount } = await ApiService.getPostsByTag({ tag: props.tag, pageNo: page, pageSize, searchableStatus });

                    resolve({
                      data: result,
                      page,
                      totalCount,
                    });
                  } catch (err) {
                    toast.error(err.message);
                    resolve({
                      data:       [],
                      page:       0,
                      totalCount: 0,
                    });
                  }
                })}
                options={{
                  actionsColumnIndex:  -1,
                  pageSize,
                  emptyRowsWhenPaging: false,
                  filtering:           false,
                  search:              false,
                  cellStyle:           {
                    fontSize: 14,
                  },
                }}
                components={{
                  Toolbar: () => (
                    <div>
                      <div>
                        <Box display="flex" justifyContent="flex-start" mt={5} p={1} bgcolor="background.paper">
                          <Box p={1} width="25%">
                            <FormControl fullWidth>
                              <InputLabel id="status-filter-label">Searchable status</InputLabel>
                              <Select
                                labelId="status-filter-label"
                                value={searchableStatus}
                                name="searchableStatus"
                                onChange={handleChange}
                              >
                                <MenuItem value="">All</MenuItem>
                                <MenuItem value={Status.Live}>{Status.Live}</MenuItem>
                                <MenuItem value={Status.Expired}>{Status.Expired}</MenuItem>
                                <MenuItem value={Status.Pending}>{Status.Pending}</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Box>
                      </div>
                    </div>
                  ),
                }}
              />
            </div>
          ) }

          { tab === 2 && (
            <div>
              <MaterialTable
                title=""
                tableRef={reviewTable}
                columns={
                  [
                    {
                      title:  'Review Id',
                      field:  'id',
                      render: (review) => (
                        <a href={`/admin/page/${review.pageId}/review/${review.id}`} target="_blank" rel="noreferrer">{ review.id }</a>
                      ),
                    },
                    {
                      title:  'Title',
                      field:  'title',
                      render: (review) => {
                        const maxLength = 50;
                        if (!IsEmpty(review.title)) {
                          return (
                            (review.title.length >= maxLength) ? `${review.title.substring(0, maxLength)}...` : review.title
                          );
                        }
                      },
                    },
                    {
                      title: 'Created Date',
                      field: 'createdAt',
                    },
                    {
                      title: 'Status',
                      field: 'status',
                    },
                    {
                      title: 'Searchable Status',
                      field: 'searchableStatus',
                    },
                  ]
                }
                onChangeRowsPerPage={(val) => setPageSize(val)}
                data={(query) => new Promise(async (resolve) => {
                  try {
                    const { page } = query;
                    const { result, totalCount } = await ApiService.getReviewsByTag({ tag: props.tag, pageNo: page, pageSize });
                    resolve({
                      data: result,
                      page,
                      totalCount,
                    });
                  } catch (err) {
                    toast.error(err.message);
                    resolve({
                      data:       [],
                      page:       0,
                      totalCount: 0,
                    });
                  }
                })}
                options={{
                  actionsColumnIndex:  -1,
                  pageSize,
                  emptyRowsWhenPaging: false,
                  filtering:           false,
                  search:              false,
                  cellStyle:           {
                    fontSize: 14,
                  },
                }}
              />
            </div>
          ) }

          { tab === 3 && (
            <div>
              <MaterialTable
                title=""
                tableRef={poiTable}
                columns={
                  [
                    {
                      title:  'Poi Id',
                      field:  'id',
                      render: (poi) => (
                        <a href={`/admin/poi/${poi.id}`} target="_blank" rel="noreferrer">{ poi.id }</a>
                      ),
                    },
                    {
                      title:  'Title',
                      field:  'title',
                      render: (poi) => {
                        const maxLength = 50;
                        if (!IsEmpty(poi.name)) {
                          return (
                            (poi.name.length >= maxLength) ? `${poi.name.substring(0, maxLength)}...` : poi.name
                          );
                        }
                      },
                    },
                    {
                      title: 'Created Date',
                      field: 'createdAt',
                    },
                    {
                      title: 'Status',
                      field: 'status',
                    },
                    {
                      title: 'Searchable Status',
                      field: 'searchableStatus',
                    },
                  ]
                }
                onChangeRowsPerPage={(val) => setPageSize(val)}
                data={(query) => new Promise(async (resolve) => {
                  try {
                    const { page } = query;
                    const { result, totalCount } = await ApiService.getPoisByTag({ tag: props.tag, pageNo: page, pageSize });
                    resolve({
                      data: result,
                      page,
                      totalCount,
                    });
                  } catch (err) {
                    toast.error(err.message);
                    resolve({
                      data:       [],
                      page:       0,
                      totalCount: 0,
                    });
                  }
                })}
                options={{
                  actionsColumnIndex:  -1,
                  pageSize,
                  emptyRowsWhenPaging: false,
                  filtering:           false,
                  search:              false,
                  cellStyle:           {
                    fontSize: 14,
                  },
                }}
              />
            </div>
          ) }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.changeOpenModal()} color="primary" style={{ fontSize: 30 }}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ViewPostsReviews.propTypes = {
  changeOpenModal: PropTypes.func.isRequired,
  tag:             PropTypes.shape([PropTypes.string]).isRequired,
};

export default connect(null, null)(ViewPostsReviews);
